/* DM · Size Chart link (Kiwi Size Chart app) moved to the end of the "Size" label row on product pages.
   The Kiwi app injects its link (.ks-chart-container) under the price; this moves that element into the
   [data-dm-sizechart-slot] placeholder rendered inside the Size legend (snippets/product-variant-options.liquid).
   Nothing else is changed: the Kiwi popup, tables and settings keep working as before. */
(function () {
  if (window.__dmSizeChart) return;
  window.__dmSizeChart = true;

  function slotFor(node) {
    var scope = node.closest('.product__content') || node.closest('[data-section-type="product"]') || node.closest('section') || document;
    return scope.querySelector('[data-dm-sizechart-slot]') || document.querySelector('[data-dm-sizechart-slot]');
  }

  function place(container) {
    if (!container || container.closest('[data-dm-sizechart-slot]')) return;
    var slot = slotFor(container);
    if (!slot) return;
    slot.appendChild(container);
    slot.classList.add('is-filled');
  }

  function scan() {
    document.querySelectorAll('.ks-chart-container').forEach(place);
  }

  function start() {
    scan();
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('.ks-chart-container')) { place(n); continue; }
          if (n.querySelector && n.querySelector('.ks-chart-container')) scan();
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
